/*
 * Planigo
 * Auteur  : Stéphane Raverdy
 * Société : SCIAD 2026
 */
import AdminPage from './AdminPage';
export default function SettingsPage() {
  return <AdminPage mode="settings" />;
}
